import { lazy } from 'react';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const ModuleLoaderLazy = lazy(()=>retry(()=>import(/* webpackChunkName: "notifications_shared" */ './ModuleLoader')));
export default ModuleLoaderLazy;
